<template>
  <div class="base-check-type-1" v-on="inputListeners">
    <div class="check-box">
      <i v-if="value" class="material-icons icon">check</i>
    </div>
    {{ propLabel }}
  </div>
</template>

<script>
export default {
  name: 'base-check-type-1',
  props: {
    propLabel: {
      default: 'LABEL',
      type: String
    },
    value: {
      default: false,
      type: Boolean
    }
  },
  created() {
    console.log('value:', this.value)
  },
  updated() {
    console.log('value:', this.value)
  },
  watch: {
    value(newValue) {
      console.log('new value:', newValue)
    }
  },
  computed: {
    inputListeners: function() {
      let vm = this
      return Object.assign({}, this.$listeners, {
        input: function(e) {
          let v = e.target.value
          vm.$emit('input', v)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.base-check-type-1 {
  width: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-weight: 600;

  .check-box {
    width: 20px;
    height: 20px;
    border: solid 1px #dbdbdb;
    background-color: #ffffff;
    margin: 0 10px 0 0;

    .icon {
      font-size: 20px;
    }
  }
}
</style>
